import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_7 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_12 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_17 = { class: "d-flex gap-3 align-items-center" }
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = {
  key: 0,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_23 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_24 = { class: "d-flex gap-3 align-items-center" }
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 3,
  class: "col-12"
}
const _hoisted_29 = {
  key: 4,
  class: "col-md-12"
}
const _hoisted_30 = { class: "d-flex align-items-center justify-content-between gap-3" }
const _hoisted_31 = {
  key: 0,
  type: "button",
  class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium",
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmModal"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-1 position-relative top-2" }, null, -1 /* HOISTED */)
const _hoisted_33 = { class: "position-relative" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "d-flex flex-wrap gap-3 justify-content-end ms-auto" }
const _hoisted_36 = { class: "row justify-content-center" }
const _hoisted_37 = { class: "col" }
const _hoisted_38 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_select = _resolveComponent("country-select")!
  const _component_ZoneConsents = _resolveComponent("ZoneConsents")!
  const _component_RoleConsents = _resolveComponent("RoleConsents")!
  const _component_ZoneJourneySchemas = _resolveComponent("ZoneJourneySchemas")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_DiscardButton = _resolveComponent("DiscardButton")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" NAME "),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('form.name.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.zone.name) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.name }]]),
                  required: ""
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.zone.name]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.name ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.name, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_8,
            _createCommentVNode(" LOCATION "),
            _createCommentVNode(" <div class=\"col-12\">\n            <h4 class=\"mb-15 mb-sm-20 mb-md-25\">{{ $t('form.section.location') }}</h4>\n          </div> "),
            _createCommentVNode(" COUNTRY "),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('form.country.label')) + "* ", 1 /* TEXT */),
                _createVNode(_component_country_select, {
                  modelValue: _ctx.zone.country_code,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.zone.country_code) = $event)),
                  country: _ctx.zone.country_code,
                  class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.country }]]),
                  required: "",
                  whiteList: "['IT','GB','FR','ES','DE']"
                }, null, 8 /* PROPS */, ["modelValue", "country", "class"]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.country ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.country, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" STRATEGY "),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('form.assignment_strategy.label')) + "* ", 1 /* TEXT */),
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select shadow-none text-black pe-50 fs-14 fw-medium",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.zone.patient_assignment_strategy) = $event)),
                    required: "",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeStrategy()))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.strategies, (strategy) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: strategy,
                        key: strategy
                      }, _toDisplayString(_ctx.$t(`form.assignment_strategy.values.${strategy}`)), 9 /* TEXT, PROPS */, _hoisted_18))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, _ctx.zone.patient_assignment_strategy]
                  ])
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.lang ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.lang, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                (_ctx.locales.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('feature.contents.lang')), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_24, [
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select shadow-none text-black pe-50 fs-14 fw-medium w-auto",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.zone.language_code) = $event)),
                          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeLang())),
                          required: ""
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (locale) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: locale,
                              key: locale
                            }, _toDisplayString(_ctx.$t(`feature.contents.$lang.${locale}`)), 9 /* TEXT, PROPS */, _hoisted_25))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                          [_vModelSelect, _ctx.zone.language_code]
                        ])
                      ]),
                      _createCommentVNode(" ERRORS "),
                      (_ctx.errors?.lang ?? false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.lang, (error) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: error,
                                class: "small text-danger lh-1 m-0 mt-1"
                              }, _toDisplayString(error), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            (_ctx.zone.patient_assignment_strategy == 'by_hcp')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createVNode(_component_ZoneConsents, {
                    hcp_consent_id: _ctx.zone.consents_ids!.hcp_consent_id,
                    "onUpdate:hcp_consent_id": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.zone.consents_ids!.hcp_consent_id) = $event))
                  }, null, 8 /* PROPS */, ["hcp_consent_id"]),
                  _createCommentVNode(" @change=\"$event => zone.consents_ids.hcp_consents_id = $event\" ")
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.update && !(_ctx.zone.zone_roles?.length === 0))
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.zone.zone_roles, (role) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: role.id
                  }, [
                    _createVNode(_component_RoleConsents, { role: role }, null, 8 /* PROPS */, ["role"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (_ctx.show_journey_schemas)
              ? (_openBlock(), _createBlock(_component_ZoneJourneySchemas, {
                  key: 2,
                  zone_id: _ctx.zone.id!,
                  roles: _ctx.journey_roles
                }, null, 8 /* PROPS */, ["zone_id", "roles"]))
              : _createCommentVNode("v-if", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createVNode(_component_SpinnerLoading)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createCommentVNode(" DELETE "),
                    (_ctx.update)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('cta.delete_zone')), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_34)),
                    _createCommentVNode(" SAVE "),
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_DiscardButton, {
                        onConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({ path: '/zones' })))
                      }),
                      _createElementVNode("button", {
                        class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                        type: "submit",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitted = true))
                      }, _toDisplayString(_ctx.$t('cta.save_zone')), 1 /* TEXT */)
                    ])
                  ])
                ]))
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[11] || (_cache[11] = ($event: any) => (_ctx.deleteZone())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}